interface TObservers {
  [key: string]: ((value?: unknown) => void)[]
}

abstract class EventEmitter {
  protected observers: TObservers = {}

  /**
   * @public
   * @param {string} eventName
   * @param {Function} observer
   */
  public on = (eventName: string, observer: (value?: any) => Promise<void> | void) => {
    if (!this.observers[eventName]) {
      this.observers[eventName] = []
    }
    this.observers[eventName].push(observer)
  }

  /**
   *
   * @public
   * @param {string} eventName
   * @param {Function} observer
   */
  public unsubscribe = (
    eventName: string,
    observer: (value?: any) => unknown | Promise<unknown>
  ) => {
    if (this.observers[eventName]) {
      const index = this.observers[eventName].indexOf(observer)
      if (~index) {
        this.observers[eventName].splice(index, 1)
      }
    }
  }

  /**
   * @private
   * @param {string} eventName
   * @param {Object|undefined} data
   */
  protected fire = (eventName: string, data: object = {}) => {
    if (this.observers[eventName]) {
      this.observers[eventName].forEach((i) => i(data))
    }
  }
}

export { EventEmitter }
